import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { v4 } from 'uuid';

import { useIam } from 'api/hooks/useIam/useIam';
import { DesktopMintTokens } from 'app/desktopMintTokens/DesktopMintTokens';
import { AppRoute } from 'routing/AppRoute.enum';
import { ProxyMetadata } from 'hooks/useAssets/useAssets.types';

export const DesktopMintTokensContainer = () => {
  const { getOwnedTokensIds, isConnected, mintTokens, transferTokens, getCreatedTokens } = useIam();
  const [ownedTokensIds, setOwnedTokensIds] = useState<string[]>([]);
  const [createdTokensIds, setCreatedTokensIds] = useState<ProxyMetadata[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { push } = useHistory();

  useEffect(() => {
    async function get() {
      setIsLoading(true);
      const tokens = await getOwnedTokensIds();
      setOwnedTokensIds(tokens);

      const createdTokens = await getCreatedTokens();
      setCreatedTokensIds(createdTokens);
      setIsLoading(false);
    }

    if (isConnected()) {
      get();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected]);

  if (!isConnected()) {
    push(AppRoute.dashboard);
  }

  const mintNewTokens = async (tokensNumber: number) => {
    setIsLoading(true);
    const newTokens = new Array(tokensNumber).fill(0).map(() => v4());
    await mintTokens(newTokens);
    const tokens = await getOwnedTokensIds();
    setOwnedTokensIds(tokens);
    setIsLoading(false);
  };

  const transferToken = async (tokens: string[], address: string) => {
    setIsLoading(true);
    await transferTokens(tokens, address);
    const ownedTokens = await getOwnedTokensIds();
    const createdTokens = await getCreatedTokens();
    setCreatedTokensIds(createdTokens);
    setOwnedTokensIds(ownedTokens);
    setIsLoading(false);
  };

  return (
    <DesktopMintTokens
      tokens={createdTokensIds.map(token => ({
        id: token.id,
        isOwnershipTransferred: !ownedTokensIds?.includes(token.id),
        isUsed: !!token.dateOfIssue,
      }))}
      transferTokens={transferToken}
      mintTokens={mintNewTokens}
      isLoading={isLoading}
    />
  );
};
